<template>
  <div>
    <div class="associate" v-if="isLike">
      <ul>
        <li @click="handleClick(item)" v-for="item in likeList" :key="item.id">{{item.question}}</li>
      </ul>
    </div>
    <div
      @click.stop="() => {}"
      :class="['send-msg', show ? 'out' : 'in']"
    >
      <input
        v-model="value"
        id="input"
        class="input"
        :placeholder="placeholder"
        v-input="{ up: handleFocus, down: handleBlur }"
        @keydown.enter="handleSubmit"
        type="text"
      />
      <div class="btn-group">
        <van-button
          v-show="value || isFocus || !showOther"
          @click="handleSubmit"
          :class="['send-btn', showOther&&!isFocus ? 'marginR10' : '']"
          type="primary"
          >{{ text }}
        </van-button>
        <van-icon
          class="other-btn"
          v-show="showOther&&!isFocus"
          @click="show = !show"
          size="30"
          color="#f07984"
          name="add-o"
        />
      </div>
      <div :class="['other-options', show ? 'in' : '']">
        <div v-show="show">
          <van-uploader accept="image/*"   :after-read="afterImgRead">
            <div class="upload-box">
              <van-icon size="50" class="kf-img" />
              <span>{{ $t('im.发送图片') }}</span>
            </div>
          </van-uploader>
          <van-uploader accept="video/*" :after-read="afterVideoRead" class="marginL20">
            <div class="upload-box">
              <van-icon size="50" class="kf-video" />
              <span>{{ $t('im.发送视频') }}</span>
            </div>
          </van-uploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {uploadFileMulti} from '@/utils/upload';
  import {apiLikeQuestion} from '@/api/Im';
  import { debounce } from '@/utils/util';
  export default {
    props: {
      text: {
        type: String,
        default: '发送',
      },
      showOther: {
        type: Boolean,
        default: false,
      },
      cdn: {
        type: String,
        default: ''
      },
      isLike: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    mounted() {
      document.addEventListener('click', () => {
        this.show = false;
      });
    },
    data() {
      return {
        value: '',
        show: false, 
        isFocus: false, 
        // 为了兼容ios
        isSubmit: false,
        likeList: []
      };
    },
    watch: {
      show(val) {
        if (val) {
          this.$emit('focus');
        }
      },
      value(val) {
        if (this.isLike) {
          if (val) {
            this.getLike(val);
          } else {
            this.likeList = [];
          }
        }
      }
    },
    methods: {
      handleFocus() {
        this.show = false;
        this.isFocus = true;
        this.$emit('focus');
      },
      handleBlur() {
        // 这为了ios 做的 不要乱动
        setTimeout(() => {
          if (!this.isSubmit) {
            this.isFocus = false;
            this.$emit('blur');
          }
          this.isSubmit = false;
        }, 10);
      },
      handleEnd() {
        // console.log(111);
      },
      handleSubmit() {
        this.isSubmit = true;
        this.focus();
        this.likeList = [];
        this.$emit('submit', this.value);
      },
      clearValue() {
        this.value = '';
      },
      
      afterImgRead(file) {
        let params = {
          file: file.file
        };
        this.afterRead(file, params, 'img');
      },
      focus(){
        this.isFocus = true;
        document.getElementById('input').focus();
      },
      afterVideoRead(file) {
        let params = {
          file: file.file
        };
        console.log(file);
        this.afterRead(file, params, 'video');
      },
      beforeVideoRead(file) {
        console.log(file);
        let uploadUrl = URL.createObjectURL(file);
        console.log(uploadUrl);
        return true;
      },
      afterRead(file,params,type) {
        let tmp_id = new Date().getTime();
        this.$emit('uping',{type,file,tmp_id});
        this.show = false;
        uploadFileMulti(params).then(res=>{
          let url =this.cdn +'/'+ res.key;
          console.log(url);
          this.$emit(type==='img'?'imgSuccess':'videoSuccess', {url,type,tmp_id});
        });
      },
      getLike:debounce(function (key_words) {
        apiLikeQuestion({key_words}).then(res => {
          if (res.code === 0) {
            if (this.value) {
              this.likeList = res.data.slice(0,3);
            }
          }
        });
      }),
      handleClick(item) {
        this.value = item.question;
        this.$emit('submit', this.value);
      }
    },
  };
</script>

<style lang="less" scoped>
.send-msg {
  position: relative;
  display: flex;
  z-index: 100;
  // align-items: center;
  padding: 10px;
  height: 34px;
  &.show {
    height: 120px;
  }

  &.in {
    // transition: height .3s ease-in;
  }

  &.out {
    height: 120px;
    transition: height 0.2s ease-out;
  }

  .input {
    flex: 1;
    height: 28px;
    background: none;
    outline: none;
    border-radius: 30px;
    background: #e9e9e9;
    padding: 3px 10px;
    border: none;
  }

  .btn-group {
    height: 34px;
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .send-btn {
    // margin-right: 10px;
  }
  .other-btn {
    color: #545454;
    // margin-left: 10px;
  }

  .other-options {
    position: absolute;
    bottom: 0;
    width: calc(100% - 40px);
    height: 0;

    &.in {
      height: 80px;
      transition: 0.3s ease-in;
    }
  }
}
.upload-box {
  display: flex;
  flex-direction: column;
}
.associate {
  padding:0 10px;
  border-bottom: 1px solid #D8D8D8;
  li {
    padding: 10px 0;
    font-size: 14px;
    color: #242424;
  }
  li+li {
    border-top: 1px solid #F7F7F7;
  }
}
</style>
